const initialState = {
  detailData: null,
  err: null,
};

export default function mediaReducer(state = initialState, action) {
  const { type, payload, err } = action;

  switch (type) {
    case 'GET_MEDIA_DETAIL':
      return initialState;

    case 'GET_MEDIA_DETAIL_SUCCESS':
      return {
        detailData: payload,
      };

    case 'GET_MEDIA_DETAIL_ERROR':
      return {
        err,
      };

    case 'CLEAR_MEDIA_DETAIL':
      return initialState;

    case 'ADD_LIST_SUCCESS':
      return {
        ...state,
        detailData: {
          ...state.detailData,
          addedToMyList: true,
        },
      };
    case 'SET_LIST_STATUS':
      return {
        ...state,
        detailData: {
          ...state.detailData,
          addedToMyList: payload,
        },
      };

    case 'ADD_LIST_ERROR':
      return {
        err,
      };
    case 'REMOVE_LIST_SUCCESS':
      return {
        ...state,
        detailData: {
          ...state.detailData,
          addedToMyList: false,
        },
      };

    case 'REMOVE_LIST_ERROR':
      return {
        err,
      };
    default:
      return state;
  }
}
